module.exports = __webpack_public_path__ + "static/media/excel.fc977de5.svg";